import { render, staticRenderFns } from "./pgResult.vue?vue&type=template&id=20278724&scoped=true&"
import script from "./pgResult.vue?vue&type=script&lang=js&"
export * from "./pgResult.vue?vue&type=script&lang=js&"
import style0 from "./pgResult.vue?vue&type=style&index=0&id=20278724&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20278724",
  null
  
)

export default component.exports